import "./second.css";
import React from "react";
import { Helmet } from 'react-helmet-async';

const Second = () => {
  return <section className="s" id="manifesto">
      <Helmet>
        <title>Our Manifesto - Bichitras Engineering Studio Philosophy</title>
        <meta name="description" content="We're not an agency. We are engineers who build, design, and move ideas forward. Our manifesto explains our approach to engineering, design, and problem-solving." />
        <meta name="keywords" content="engineering manifesto, design philosophy, engineering studio values, problem solving approach, business solutions" />
      </Helmet>
      <h2 className="mani">Manifesto</h2>
      <div className="text-way">
          <p className="about">
          We're not an agency. We are engineers who build, <br />
          design, and move ideas forward. We're not <br />
          industry veterans. But we're here with bold ideas, <br />
          clean execution and a drive to solve problems. <br />
          We started with nothing but clarity, code, and curiosity.
          </p>

        <p className="about-2">
          We don't just design things. We design systems. <br />
          From startups to hospitals to factories - we bring <br />
          engineering logic to creative work. <br />
          We design, develop, and scale. We make business <br />
          understandable, presentable, and functional. <br />
          <br />
          <strong>This is Bichitras.</strong>
          <br />
          A studio born from curiosity and code. Built by people <br />
          who still stay up all night to make things better. <br />
        </p>



      </div>
      <div className="oval">
      <lottie-player
        autoplay
        loop
        mode="normal"
        src="https://assets2.lottiefiles.com/packages/lf20_avndu8kw.json"
        aria-label="Animated logo representation"
        >
    </lottie-player>
      </div>
  </section>;
};

export default Second;
